export default __webpack_public_path__ + "static/media/speaker.c618cabe.jpeg";